import { app } from '../../bootstrap/core';
import { UserService } from './user.service';
import { ifRole, unlessRole, hasPermission, somePermission } from './user.directive';
import { UserRoles, UserPermissions } from './user.roles';

app.service('User', UserService);
app.service('userService', UserService);
app.directive('ifRole', ifRole);
app.directive('unlessRole', unlessRole);
app.directive('hasPermission', hasPermission);
app.directive('somePermission', somePermission);
app.value('UserRoles', UserRoles);
app.constant('UserPermissions', UserPermissions);
